export default __webpack_public_path__ + "static/media/041-security man.7ebff4da.svg";